// @ts-nocheck
/* eslint-disable */
// external script which had to be copied and pasted thus disabling typescript check

export function customerio(element: HTMLScriptElement) {
  const cdpApiKey = import.meta.env.VITE_APP_CUSTOMERIO_CDP_API_KEY;
  const i = 'cioanalytics';

  const analytics = (window[i] = window[i] || []);

  if (!analytics.initialize) {
    if (analytics.invoked) {
      console.error('Customer.io snippet included twice.');
    } else {
      analytics.invoked = true;
      analytics.methods = [
        'trackSubmit',
        'trackClick',
        'trackLink',
        'trackForm',
        'pageview',
        'identify',
        'reset',
        'group',
        'track',
        'ready',
        'alias',
        'debug',
        'page',
        'once',
        'off',
        'on',
        'addSourceMiddleware',
        'addIntegrationMiddleware',
        'setAnonymousId',
        'addDestinationMiddleware',
      ];

      analytics.factory = (e) => {
        return function () {
          const t = Array.prototype.slice.call(arguments);
          t.unshift(e);
          analytics.push(t);
          return analytics;
        };
      };

      for (let e = 0; e < analytics.methods.length; e++) {
        const key = analytics.methods[e];
        analytics[key] = analytics.factory(key);
      }

      analytics.load = (key, e) => {
        const t = document.createElement('script');
        t.type = 'text/javascript';
        t.async = true;
        t.setAttribute('data-global-customerio-analytics-key', i);
        t.src =
          'https://cdp.customer.io/v1/analytics-js/snippet/' +
          key +
          '/analytics.min.js';
        const n = document.getElementsByTagName('script')[0];
        n.parentNode.insertBefore(t, n);
        analytics._writeKey = key;
        analytics._loadOptions = e;
      };

      analytics.SNIPPET_VERSION = '4.15.3';
      analytics.load(cdpApiKey, {
        integrations: {
          'Customer.io In-App Plugin': {
            events: (event) => {
              switch (event.type) {
                case 'in-app:message-opened':
                  console.log('[Customer.io] Message opened:', event.detail);
                  break;
                case 'in-app:message-dismissed':
                  console.log('[Customer.io] Message dismissed:', event.detail);
                  break;
                case 'in-app:message-action':
                  console.log('[Customer.io] Message action:', event.detail);
                  break;
                case 'in-app:message-error':
                  console.error('[Customer.io] Message error:', event.detail);
                  break;
              }
            },
          },
        },
      });
      analytics.page();
    }
  }

  return element;
}
